@if (inventory) {
  <div class="table-responsive label-selector-table">
    <table class="qty-table">
      @for (sizeRange of inventory.sizeRanges; track sizeRange) {
        <tbody>
          <tr>
            <td rowspan="3" class="print-size-range-label-cell">{{ sizeRange.name }}</td>
            <td>&nbsp;</td>
            @for (size of sizeRange.sizes; track size) {
              <td class="print-size-label-header-cell">{{ size.label }}</td>
            }
          </tr>
          <tr>
            <td class="print-selector-header-cell">{{ 'App_LabelType' | translate }}</td>
            @for (size of sizeRange.sizes; track size) {
              <td class="print-selector-cell">
                <dx-number-box id="sizeLabel"
                  class="print-selector"
                  [min]="0"
                  [showSpinButtons]="true"
                  [value]="getTotalLabelsToPrint(sizeRange, size)"
                  (onValueChanged)="updateTotalLabelsToPrint(sizeRange, size, $event)">
                </dx-number-box>
              </td>
            }
          </tr>
          <tr>
            <td class="print-summary-header-cell">{{ 'App_InStock' | translate }}</td>
            @for (size of sizeRange.sizes; track size) {
              <td class="print-summary-cell">{{ getTotalItems(sizeRange, size) || '&nbsp;' }}</td>
            }
          </tr>
        </tbody>
      }
    </table>
  </div>
}
